<template>
	<CCard>
		<CCardHeader>
			<h5>Notes internes</h5>
		</CCardHeader>
		<div ref="chat" class="internal-container">
			<template v-for="note in ticket.notes">
				<MessageBubble
					:author="note.createdBy.email"
					:created-at="note.createdAt"
					:message="note.content"
					:is-author="true" />
			</template>
		</div>

		<div class="p-3">
			<form ref="noteForm" action="/api/support_notes" method="POST" axiosMethod="post">
				<CTextarea label="Ecrire une note" name="content" v-model="message" />
				<CInput type="hidden" name="supportTicket" :value="ticket['@id']" />
			</form>
			<GLoadingButton
				:loading="loading"
				label="Envoyer"
				@click="onSubmit($refs.noteForm)"
				class="btn-submit float-right"
				color="success" />
		</div>
	</CCard>
</template>

<script>
	import MessageBubble from './MessageBubble';
	import GLoadingButton from '../../../../../components/ghostlexly-components/GLoadingButton';

	export default {
		components: { GLoadingButton, MessageBubble },
		props: {
			ticket: Object,
		},
		data() {
			return {
				loading: false,
				message: null,
			};
		},
		methods: {
			onSubmit(form) {
				this.loading = true;
				this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.$emit('new:note', res.data);
						this.$nextTick(() => this.$refs.chat.scrollTo(0, this.$refs.chat.scrollHeight));
					}

					this.loading = false;
					this.message = null;
				});
			},
		},
		mounted() {
			this.$refs.chat.scrollTo(0, this.$refs.chat.scrollHeight);
		},
	};
</script>

<style>
	.internal-container {
		display: flex;
		flex-direction: column;
		padding: 20px;
		overflow-y: scroll;
		height: 220px;
	}

	.internal-container .bubble-container {
		width: 100%;
		max-width: 100%;
	}

	.internal-container .bubble-you {
		background-color: #f0f2f5;
		color: rgb(5, 5, 5);
	}

	.btn-submit {
		width: fit-content;
		align-self: flex-end;
	}

	.justify-self-end {
		justify-self: flex-end;
	}
</style>
